import { QueryKeysConfig } from "@/config/query-keys";
import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { useNavigate, useRouter, useSearch } from "@tanstack/react-router";
import { getAppMenuSect, setAppMenuSect } from "@/persistence/app-menu";

export const APP_MENU_KEY = "menu";
export const APP_MENU_ACTIVE_VALUE = "y";
export const useOpenAppMenu = () => {
  const nav = useNavigate();
  return () =>
    nav({
      to: ".",
      search: (prev) => ({
        ...prev,
        [APP_MENU_KEY]: APP_MENU_ACTIVE_VALUE,
      }),
    });
};

export const useCloseAppMenu = () => {
  const router = useRouter();
  return () => {
    if (router.history.canGoBack()) {
      router.history.back();
    } else {
      router.navigate({ to: ".", replace: true, search: {} });
    }
  };
};
export const useAppMenuVisibilityState = () => {
  return useSearch({
    from: "__root__",
    select: (params) => params[APP_MENU_KEY] === APP_MENU_ACTIVE_VALUE,
  });
};

export const useAppMenuSection = () => {
  return useSuspenseQuery({
    queryKey: [QueryKeysConfig.appMenuSect],
    queryFn: getAppMenuSect,
    gcTime: Infinity,
    staleTime: Infinity,
  }).data;
};
export const useChangeAppMenuSection = () => {
  const queryClient = useQueryClient();
  return async (sect: string) => {
    queryClient.setQueryData([QueryKeysConfig.appMenuSect], sect);
    setAppMenuSect(sect);
  };
};
